import { render, staticRenderFns } from "./IndexDashboardComponent.vue?vue&type=template&id=434055c7&scoped=true&"
import script from "./IndexDashboardComponent.vue?vue&type=script&lang=js&"
export * from "./IndexDashboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndexDashboardComponent.vue?vue&type=style&index=0&id=434055c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434055c7",
  null
  
)

export default component.exports